'use client'

import { FormEventHandler } from 'react'
import { Button } from 'ui/button'
import { Card, CardContent, CardHeader, CardTitle } from 'ui/card'
import { Input } from 'ui/input'
import { Label } from 'ui/label'
import { Textarea } from 'ui/textarea'

interface ContactUsTexts {
    contactUs: string
    email: string
    message: string
    send: string
}

const ContactUs = ({ user, t }: { user: IUser | null; t: ContactUsTexts }) => {
    const formSubmitHandler: FormEventHandler = (event): void => {
        const form = event.target as HTMLFormElement
        event.preventDefault()
        let email
        if (user) email = user.email
        else email = form.email.value
        const message = form.message.value

        const requestPayload = {
            email,
            message
        }

        console.log(requestPayload)
    }

    return (
        <Card className='lg:w-[90%] w-[90%] mx-auto mt-[10px]'>
            <CardHeader>
                <CardTitle>{t.contactUs}</CardTitle>
            </CardHeader>
            <CardContent>
                <form className='admin_form_style' onSubmit={formSubmitHandler}>
                    {user === null && (
                        <>
                            <Label>{t.email}</Label>
                            <Input name='email' type='email' placeholder='example@email.com' />
                        </>
                    )}
                    <Label>{t.message}</Label>
                    <Textarea className='resize-none' rows={5} name='message' required />
                    <Button type='submit' className='ml-auto'>
                        {t.send}
                    </Button>
                </form>
            </CardContent>
        </Card>
    )
}

export default ContactUs
